import {
  GET_REPORT_BY_SERVICE,
  GET_REPORT_BY_TYPE,
  GET_REPORT_RESTAURANT,
  GET_SETTLEMENT_REPORT,
  GET_SETTLEMENT_TYPE_REPORT,
  GET_ORDER_ITEM_TAX,
  GET_PAYMENT_ORDER,
  GET_PAYMENT_EVENT,
  GET_PAYMENT_SCAN,
  GET_INVOICE,
  GET_SCAN_AND_PAY_ACTIVITY,
  GET_EVENT,
  GET_ALL_ORDER,
  GET_EVENT_SUMMARY,
  GET_EXP_SUMMARY,
  GET_OFFER_VENDOR,
  GET_OFFERS_ACTIVITY,
  GET_OFFER_SUMMARY,
  GET_ADMIN_OFFER_VENDOR,
  GET_ADMIN_SEATING_PENDING_ACTIVITY,
  GET_ADMIN_SEATING_ACTIVITY,
  GET_ADMIN_SEATING_SUMMARY,
  GET_ADMIN_SEATING_VENDOR,
  GET_ITEM_REPORT_VENDOR,
  GET_SCAN_AND_PAY_REPORT_VENDOR,
  GET_ADMIN_ITEM_SUMMARY,
  GET_ADMIN_ITEM_VENDOR,
  GET_ALL_SEATING_VENDOR,
  GET_SEATING_PENDING_VENDOR,
  GET_EVENT_VENDOR,
  GET_EXP_VENDOR,
  GET_USER_REGISTRATIONS
} from "../../types";

const initState = {
  liveReport: {},
  hourlyReport: [],
  rangeReport: [],
  settlemetReport: [],
  settlement_type_report: [],
  order_item_tax: [],
  payment_order: [],
  payment_event: [],
  payment_scan: [],
  invoice: [],
  scanAndPayActivity: [],
  eventReport: [],
  allorderreport: [],
  admin_event_summary: [],
  admin_exp_summary: [],
  offer_vendor: [],
  admin_offer_activity: [],
  admin_offer_summary: [],
  admin_offer_vendor: [],
  admin_seating_pending_activity: [],
  admin_seating_activity: [],
  admin_seating_summary: [],
  admin_seating_vendor: [],
  vendor_item_report: [],
  vendor_scan_and_pay_report: [],
  admin_item_summary: [],
  vendor_all_Seating: [],
  seating_pending_vendor: [],
  admin_event_vendor: [],
  admin_exp_vendor: [],
  user_registrations_amealio: [],
};

export default function (state = initState, action) {
  switch (action.type) {
    case GET_REPORT_RESTAURANT:
      //   console.log(action.payload);
      return {
        ...state,
        liveReport: action.payload,
      };
    case GET_REPORT_BY_SERVICE:
      return {
        ...state,
        hourlyReport: action.payload,
      };
    case GET_REPORT_BY_TYPE:
      return {
        ...state,
        rangeReport: action.payload,
      };
    case GET_SETTLEMENT_REPORT:
      return {
        ...state,
        settlemetReport: action.payload,
      };
    case GET_SETTLEMENT_TYPE_REPORT:
      return {
        ...state,
        settlement_type_report: action.payload,
      };
    case GET_ORDER_ITEM_TAX:
      return {
        ...state,
        order_item_tax: action.payload,
      };
    case GET_PAYMENT_ORDER:
      return {
        ...state,
        payment_order: action.payload,
      };
    case GET_PAYMENT_EVENT:
      return {
        ...state,
        payment_event: action.payload,
      };
    case GET_PAYMENT_SCAN:
      return {
        ...state,
        payment_scan: action.payload,
      };
    case GET_INVOICE:
      return {
        ...state,
        invoice: action.payload,
      };
    case GET_SCAN_AND_PAY_ACTIVITY:
      return {
        ...state,
        scanAndPayActivity: action.payload,
      };
    case GET_EVENT:
      return {
        ...state,
        eventReport: action.payload,
      };
    case GET_ALL_ORDER:
      return {
        ...state,
        allorderreport: action.payload,
      };
    case GET_EVENT_SUMMARY:
      return {
        ...state,
        admin_event_summary: action.payload,
      };
    case GET_EXP_SUMMARY:
      return {
        ...state,
        admin_exp_summary: action.payload,
      };
    case GET_OFFER_VENDOR:
      return {
        ...state,
        offer_vendor: action.payload,
      };
    case GET_OFFERS_ACTIVITY:
      return {
        ...state,
        admin_offer_activity: action.payload,
      };
    case GET_OFFER_SUMMARY:
      return {
        ...state,
        admin_offer_summary: action.payload,
      };
    case GET_ADMIN_OFFER_VENDOR:
      return {
        ...state,
        admin_offer_vendor: action.payload,
      };
    case GET_ADMIN_SEATING_PENDING_ACTIVITY:
      return {
        ...state,
        admin_seating_pending_activity: action.payload,
      };
    case GET_ADMIN_SEATING_ACTIVITY:
      return {
        ...state,
        admin_seating_activity: action.payload,
      };
    case GET_ADMIN_SEATING_SUMMARY:
      return {
        ...state,
        admin_seating_summary: action.payload,
      };
    case GET_ADMIN_SEATING_VENDOR:
      return {
        ...state,
        admin_seating_vendor: action.payload,
      };
    case GET_ITEM_REPORT_VENDOR:
      return {
        ...state,
        vendor_item_report: action.payload,
      };
    case GET_SCAN_AND_PAY_REPORT_VENDOR:
      return {
        ...state,
        vendor_scan_and_pay_report: action.payload,
      };
    case GET_ADMIN_ITEM_SUMMARY:
      return {
        ...state,
        admin_item_summary: action.payload,
      };
    case GET_ALL_SEATING_VENDOR:
      return {
        ...state,
        vendor_all_Seating: action.payload,
      };
    case GET_SEATING_PENDING_VENDOR:
      return {
        ...state,
        seating_pending_vendor: action.payload,
      };
    case GET_EVENT_VENDOR:
      return {
        ...state,
        admin_event_vendor: action.payload,
      };
    case GET_EXP_VENDOR:
      return {
        ...state,
        admin_exp_vendor: action.payload,
      };
    case GET_USER_REGISTRATIONS:
      return {
        ...state,
        user_registrations_amealio: action.payload,
      };
    default:
      return state;
  }
}
